import { Dropdown } from 'antd';
import styled from 'styled-components';

export const StyledBasicDropdown = styled(Dropdown)``;
